import React, { useState, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import BottomNavItem from '../BottomNavItem'
import StyledBottomNav from './styles'
import { Box } from '../Box'
import DropdownMenu from '../DropdownMenu/DropdownMenu'
import { BottomNavProps } from './types'
import { NotificationDot } from '../NotificationDot'
import { Overlay } from '../Overlay'

const BottomNav: React.FC<BottomNavProps> = ({ items = [], ...props }) => {
  const { pathname } = useLocation()
  const [menuOpenByIndex, setMenuOpenByIndex] = useState({})
  const isBottomMenuOpen = Object.values(menuOpenByIndex).reduce((acc, value) => acc || value, false)

  const isBlackThemePage = useMemo(() => pathname === '/' || pathname === '/nft/launchpad', [pathname])
  return (
    <>
      {isBottomMenuOpen && <Overlay show />}
      <StyledBottomNav justifyContent="space-around" {...props} isBlackThemePage={isBlackThemePage}>
        {items.map(({ label, items: menuItems, href, icon, showOnMobile = true }, index) => {
          const statusColor = menuItems?.find((menuItem) => menuItem.status !== undefined)?.status?.color
          return (
            showOnMobile && (
              <DropdownMenu
                key={label}
                items={menuItems}
                isBottomNav
                showItemsOnMobile={menuItems?.length > 0}
                setMenuOpenByIndex={setMenuOpenByIndex}
                index={index}
              >
                <Box>
                  <NotificationDot show={!!statusColor} color={statusColor}>
                    <BottomNavItem
                      href={href}
                      isActive={href === pathname || menuItems?.some((item) => item.href === pathname)}
                      label={label}
                      iconName={icon}
                      showItemsOnMobile={menuItems?.length > 0}
                    />
                  </NotificationDot>
                </Box>
              </DropdownMenu>
            )
          )
        })}
      </StyledBottomNav>
    </>
  )
}

export default BottomNav
